module.exports = __webpack_public_path__ + "static/media/detectDataImage9.e81ae70a.png";